import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Checkbox,
  FormControlLabel,
  Paper,
  Typography,
} from "@mui/material";

const PermissionTable = ({ groupedModules, onSelectionChange }) => {
  const [permissionsState, setPermissionsState] = useState({});

  useEffect(() => {
    const initial = {};
    groupedModules.forEach((module) => {
      initial[module.id] = {};
      module.permissions.forEach((p) => {
        initial[module.id][p.name] = p.selected || false;
      });
    });
    setPermissionsState(initial);
    onSelectionChange(collectSelectedPermissionIds(initial));
  }, [groupedModules]);

  const collectSelectedPermissionIds = (state) => {
    const selected = [];
    groupedModules.forEach((module) => {
      module.permissions.forEach((p) => {
        if (state[module.id]?.[p.name]) selected.push(p.id);
      });
    });
    return selected;
  };

  const handlePermissionChange = (module, permName, value) => {
    setPermissionsState((prev) => {
      const updated = { ...prev };
      const modulePerms = { ...updated[module.id] };

      const allPerm = module.permissions.find(
        (p) => p.displayName.toLowerCase() === "all"
      );

      if (allPerm && permName === allPerm.name) {
        module.permissions.forEach((p) => (modulePerms[p.name] = value));
      } else {
        modulePerms[permName] = value;

        if (allPerm) {
          const allChecked = module.permissions
            .filter((p) => p.name !== allPerm.name)
            .every((p) => modulePerms[p.name] === true);

          modulePerms[allPerm.name] = allChecked;
        }
      }

      updated[module.id] = modulePerms;
      onSelectionChange(collectSelectedPermissionIds(updated));
      return updated;
    });
  };

  const allPermissionNames = [
    ...new Set(
      groupedModules.flatMap((m) =>
        m.permissions.map((p) => p.displayName || p.name)
      )
    ),
  ].sort();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {groupedModules.map((module) => (
            <TableRow key={module.id}>
              <TableCell sx={{ fontWeight: "bold" }}>{module.name}</TableCell>

              {allPermissionNames.map((label) => {
                const perm = module.permissions.find(
                  (p) => (p.displayName || p.name) === label
                );
                return (
                  <TableCell key={label}>
                    {perm && (
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={permissionsState[module.id]?.[perm.name] || false}
                            onChange={(e) =>
                              handlePermissionChange(module, perm.name, e.target.checked)
                            }
                          />
                        }
                        label={perm.displayName}
                      />
                    )}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PermissionTable;
